import { ruleTypeToVisibility, visibilityOptions, visibilityToRuleType } from '../constants/ArticleVisibilityConstants';
import { EMPTY_ARRAY } from '../constants/SharedConstants';
import { PublicAccessRuleTypes } from 'ui-memberships-settings-lib/constants/PublicAccessRuleTypes';
import { AccessControlTypes } from 'ui-memberships-settings-lib/constants/AccessControlTypes';
export function getInitialVisibilityParams() {
  return {
    originalSelectedLists: EMPTY_ARRAY,
    selectedLists: EMPTY_ARRAY,
    selectedVisibility: visibilityOptions.ALL_AUDIENCE
  };
}
export function getVisibilityForArticle(article) {
  if (article.values.hs_access_rule_type) {
    return ruleTypeToVisibility[article.values.hs_access_rule_type] || visibilityOptions.RESTRICTED;
  }
  return visibilityOptions.PUBLIC;
}
export function getVisibilityForDisplay(article, membershipSsoEnabled) {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
  const visibility = getVisibilityForArticle(article, membershipSsoEnabled);
  if (membershipSsoEnabled) {
    return visibility === visibilityOptions.RESTRICTED ? visibilityOptions.SSO_WITH_SPECIFIC_CONTACTS : visibility;
  } else {
    return visibility === visibilityOptions.SSO ? visibilityOptions.PUBLIC : visibility;
  }
}
export function getListsForArticle(article) {
  return article.values.hs_access_rule_ids || [];
}
export function getListsFromPayload(payload) {
  return payload.hs_access_rule_ids || [];
}
export function getVisibilityParamsFromArticle(article) {
  const selectedVisibility = getVisibilityForArticle(article);
  const selectedLists = isVisibilityRestricted(selectedVisibility) ? getListsForArticle(article) : [];
  return {
    originalSelectedLists: selectedLists,
    selectedLists,
    selectedVisibility
  };
}
export function getArticlePayload({
  selectedLists,
  selectedVisibility
}) {
  const accessRuleType = visibilityToRuleType[selectedVisibility];
  return {
    hs_access_rule_type: accessRuleType,
    hs_access_rule_ids: selectedLists
  };
}
export function hasNoSelectedListsError({
  selectedLists,
  selectedVisibility
}) {
  return selectedVisibility === visibilityOptions.RESTRICTED && selectedLists.length === 0;
}
export function hasNoSelectedAccessGroupsError({
  selectedLists,
  selectedVisibility
}) {
  return (selectedVisibility === visibilityOptions.ACCESS_GROUP_MEMBERSHIP || selectedVisibility === visibilityOptions.SSO_WITH_ACCESS_GROUPS) && selectedLists.length === 0;
}
export function getVisibilityForRequest(payload) {
  return ruleTypeToVisibility[payload.hs_access_rule_type];
}
export function isRequestVisibilityRestricted(payload) {
  const visibility = getVisibilityForRequest(payload);
  return visibility !== visibilityOptions.PUBLIC;
}
export function isVisibilityRestricted(visibility) {
  return visibility !== visibilityOptions.PUBLIC;
}
export const areSelectedListsEqual = (originalSelectedLists, selectedLists) => originalSelectedLists.length === selectedLists.length || selectedLists.length > 0 && selectedLists.every(list => originalSelectedLists.includes(list));
export function getTotalContacts(selectedLists = [], listsDetail) {
  return selectedLists.reduce((acc, listId) => acc + (listsDetail.has(listId) ? listsDetail.get(listId).metaData.size : 0), 0);
}
export const getLegacyArticlePayload = payload => {
  return {
    publicAccessRulesEnabled: payload.hs_access_rule_type !== PublicAccessRuleTypes.PUBLIC,
    publicAccessRules: payload.hs_access_rule_type && payload.hs_access_rule_type !== PublicAccessRuleTypes.PUBLIC && [{
      type: payload.hs_access_rule_type,
      ids: payload.hs_access_rule_ids
    }] || []
  };
};
export const getContentAccessControlOptions = ({
  knowledgeBaseAccessType,
  isKnowledgeBasePrivate
}) => {
  // KB v3 SSO_LOGIN only
  if (knowledgeBaseAccessType === PublicAccessRuleTypes.SSO_LOGIN) {
    return {
      [AccessControlTypes.SSO]: true
      // TODO: add back after HubDB supports this [AccessControlTypes.SSO_WITH_ACCESS_GROUPS]: true,
    };
  }
  // KB v3 ACCESS_GROUP_MEMBERSHIP only
  else if (knowledgeBaseAccessType === PublicAccessRuleTypes.ACCESS_GROUP_MEMBERSHIP) {
    return {
      [AccessControlTypes.ACCESS_GROUP_MEMBERSHIP]: true
    };
  }
  // KB v2 - Private only
  else if (isKnowledgeBasePrivate) return {
    [AccessControlTypes.ACCESS_GROUP_MEMBERSHIP]: true,
    [AccessControlTypes.SSO]: true,
    [AccessControlTypes.SSO_WITH_ACCESS_GROUPS]: true
  };
  // KB v2, KB v3 - Public and private
  else if (knowledgeBaseAccessType === PublicAccessRuleTypes.PUBLIC || !isKnowledgeBasePrivate) {
    return {
      [AccessControlTypes.PUBLIC]: true,
      [AccessControlTypes.ACCESS_GROUP_MEMBERSHIP]: true,
      [AccessControlTypes.SSO]: true,
      [AccessControlTypes.SSO_WITH_ACCESS_GROUPS]: true
    };
  } else {
    return {};
  }
};